/**
 * contact-form-gorgias.js
 * Intercepts Shopify contact form
 */

(function () {
  var API_URL = 'https://gc-tickets.vercel.app/api/create-ticket';

  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.search.includes('contact_posted=true')) {
      var url = new URL(window.location);
      url.searchParams.delete('contact_posted');
      window.history.replaceState({}, '', url.toString());
      var shopifySuccess = document.querySelector('.form-success.contact-form__full-width');
      if (shopifySuccess) shopifySuccess.remove();
    }

    var form = document.querySelector('form[accept-charset="UTF-8"]');

    if (!form) {
      return;
    }

    var newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);

    // Inject honeypot field (hidden from humans, bots auto-fill it)
    var hpDiv = document.createElement('div');
    hpDiv.style.cssText = 'position:absolute;left:-9999px;opacity:0;';
    hpDiv.setAttribute('aria-hidden', 'true');
    var hpInput = document.createElement('input');
    hpInput.type = 'text';
    hpInput.name = 'website_url_confirm';
    hpInput.tabIndex = -1;
    hpInput.autocomplete = 'off';
    hpDiv.appendChild(hpInput);
    newForm.appendChild(hpDiv);

    newForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Honeypot check — bots auto-fill hidden fields
      var hp = newForm.querySelector('[name="website_url_confirm"]');
      if (hp && hp.value) return;

      var formData = new FormData(newForm);
      var fields = Object.fromEntries(formData);

      if (!fields['contact[email]']) {
        return;
      }

      var submitBtn = newForm.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      var email = fields['contact[email]'] || '';
      var firstName = fields['contact[first_name]'] || '';
      var lastName = fields['contact[last_name]'] || '';
      var phone = fields['contact[phone]'] || '';
      var fax = fields['contact[fax]'] || '';
      var state = fields['contact[state]'] || '';
      var country = fields['contact[country]'] || '';
      var message = fields['contact[body]'] || '';

      var tags = ['contact-form', 'website-inquiry'];
      if (isInternational(country)) {
        tags.push('international-' + sanitizeTag(country));
      }

      try {
        var result = await sendToGorgias({
          formType: 'contact-form',
          email: email,
          name: (firstName + ' ' + lastName).trim(),
          firstName: firstName,
          lastName: lastName,
          phone: phone,
          fax: fax,
          state: state,
          country: country,
          notes: message,
          subject: ('Customer Inquiry - ' + firstName + ' ' + lastName).trim(),
          tags: JSON.stringify(tags)
        });

        if (result) {
          showSuccessMessage(newForm, result.ticketId);
          newForm.reset();
        } else {
          showErrorMessage(newForm, 'Failed to send. Please try again.');
        }

      } catch (error) {
        showErrorMessage(newForm, 'An error occurred. Please try again.');
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }

      return false;
    }, true);

    function sanitizeTag(str) {
      if (!str) return 'unknown';
      return str.toLowerCase().replace(/[^a-z0-9\-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '').substring(0, 100) || 'unknown';
    }

    function isInternational(country) {
      if (!country || !country.trim()) return false;
      var normalized = country.toLowerCase().trim();
      var domestic = ['united states', 'usa', 'us', 'united states of america', 'america'];
      return !domestic.some(function (c) {
        return normalized === c || normalized.includes(c);
      });
    }

    async function sendToGorgias(payload) {
      try {
        var formData = new FormData();
        for (var key in payload) {
          formData.append(key, payload[key]);
        }
        var resp = await fetch(API_URL, {
          method: 'POST',
          body: formData
        });
        var result = await resp.json();
        if (!resp.ok) {
          return null;
        }
        return result;
      } catch (err) {
        return null;
      }
    }

    function showSuccessMessage(form, ticketId) {
      var successMsg = document.createElement('p');
      successMsg.className = 'form-success contact-form__full-width';
      successMsg.textContent = 'Thank you! We have received your message. Ticket #' + (ticketId || '');
      successMsg.style.color = '#155724';
      successMsg.style.background = '#d4edda';
      successMsg.style.padding = '12px';
      successMsg.style.borderRadius = '4px';
      successMsg.style.marginBottom = '20px';
      form.parentNode.insertBefore(successMsg, form);
      setTimeout(function () { successMsg.remove(); }, 5000);
    }

    function showErrorMessage(form, message) {
      var errorMsg = document.createElement('p');
      errorMsg.className = 'form-errors contact-form__full-width';
      errorMsg.textContent = message;
      errorMsg.style.color = '#721c24';
      errorMsg.style.background = '#f8d7da';
      errorMsg.style.padding = '12px';
      errorMsg.style.borderRadius = '4px';
      errorMsg.style.marginBottom = '20px';
      form.parentNode.insertBefore(errorMsg, form);
      setTimeout(function () { errorMsg.remove(); }, 5000);
    }
  });
})();
